import type React from "react";
import { cn } from "@/lib/utils";

interface SidebarSectionHeadingProps {
  as?: "h2" | "h3";
  icon?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

export const SidebarSectionHeading: React.FC<SidebarSectionHeadingProps> = ({
  as: Heading = "h2",
  icon,
  children,
  className,
}) => (
  <Heading
    className={cn(
      "flex min-w-0 shrink items-center gap-1.5 whitespace-nowrap text-base font-semibold leading-6 text-rw-dark-gray [@media(max-height:700px)]:text-sm [@media(max-height:700px)]:leading-5",
      className,
    )}
  >
    {icon}
    {children}
  </Heading>
);
